import React from 'react';
import useWindowDimensions from '@/app/hooks/useWindowSize';
import { ADDING_TO_CART } from '@/constants';
import { cn } from '@/utils/cn';
import { screenTypes } from '@/constants/types';
import LoadingSpinnerV2 from '../Skeleton/LoadingSpinnerV2';
import ButtonLabel from '../Typography/ButtonLabel';

function LoadingToCartButton({ className, iconStyle = '', labelStyle = '' }) {
  const { width: screenWidth } = useWindowDimensions();

  return (
    <button
      type="button"
      aria-label={ADDING_TO_CART}
      className={cn(
        'w-[124px] lg:w-[200px] h-[24px] lg:h-[36px] rounded-[100px] flex justify-center items-center gap-[6px] lg:gap-[8px] px-[16px] bg-aquarelle-purple border-himalayan-poppy border-[1px] hover:cursor-not-allowed',
        className,
      )}
    >
      <LoadingSpinnerV2
        size={iconStyle || (screenWidth >= screenTypes.large ? '20' : '14')}
        className="bg-transparent"
      />

      <ButtonLabel
        label={ADDING_TO_CART}
        className={cn(
          'text-xs lg:text-sm font-semibold lg:font-bold text-atelier text-left',
          labelStyle,
        )}
      />
    </button>
  );
}

export default LoadingToCartButton;
